export default __webpack_public_path__ + "static/media/11.375faa8a.png";